import React from 'react';
import { connect } from 'react-redux';

const VideoPlayer = React.memo( ( {
  className, src, locale,
} ) => {
  const cl = `embed-responsive embed-responsive-16by9 ${className}`;

  const s = {
    es: '',
    en: '',
    ...src,
  };

  return (
    <div className={cl}>
      <iframe
        className="embed-responsive-item"
        src={s[locale.locale]}
        title="Massphoning"
        allowFullScreen
        frameBorder="0"
        allow="autoplay; fullscreen"
      />
    </div>
  );
} );

const mapStateToProps = ( { settings } ) => ( {
  locale: settings.locale,
} );

export default connect( mapStateToProps, null )( VideoPlayer );
